import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Box } from '../box/box';
import { naturalHeightOnPhoneSx } from '../style/phone-page-scroll';
import { NavigationMenu, SIDE_MENU_QUERY } from './navigation-menu';
import { SettingsRouteConfiguration } from './settings-route-configuration';
import { SidebarTabsLayoutProps } from './types';

export const SidebarTabsLayoutComponent = ({
  routesConfigItems,
  onChangeSubMenu,
}: SidebarTabsLayoutProps) => {
  const location = useLocation();

  useEffect(() => {
    if (!routesConfigItems?.length || !onChangeSubMenu) return;

    const tabPaths = routesConfigItems
      .map((item) => item.path)
      .filter((p): p is string => Boolean(p));

    const hasTabInPath = tabPaths.some((tabPath) =>
      location.pathname.includes(`/${tabPath}`)
    );

    if (!hasTabInPath) {
      const firstWithPath = routesConfigItems.find((item) => item.path);
      if (firstWithPath) {
        onChangeSubMenu(firstWithPath.path);
      }
    }
  }, [location.pathname, routesConfigItems, onChangeSubMenu]);
  return (
    <Box
      sx={{
        containerType: 'inline-size',
        height: '100%',
        minHeight: 0,
        width: '100%',
        ...naturalHeightOnPhoneSx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          height: '100%',
          minHeight: 0,
          overflow: 'hidden',
          paddingTop: '4px',
          [SIDE_MENU_QUERY]: { flexDirection: 'row', gap: '16px' },
          ...naturalHeightOnPhoneSx,
        }}
        width={'100%'}
      >
        <NavigationMenu
          items={routesConfigItems}
          onChangeSubMenu={(route) => onChangeSubMenu(route)}
        />
        <Box
          className="profile"
          sx={{
            flex: 1,
            display: 'flex',
            minHeight: 0,
            minWidth: 0,
            overflow: 'hidden',
            ...naturalHeightOnPhoneSx,
          }}
        >
          <SettingsRouteConfiguration items={routesConfigItems} />
        </Box>
      </Box>
    </Box>
  );
};
